

















import { Component, Vue, Prop } from 'vue-property-decorator';
import MyProfileDetails from '@/components/MyProfileDetails.vue';
import { vxm } from '../../store.vuex';
@Component({
  components: {
    MyProfileDetails,
  },
})
export default class Address extends Vue {
  @Prop() bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Prop() isLastStep;
 
  disableNext(val) {
    this.$emit('disable-next-button', val);
  }

  async goToNext() {
    await vxm.users.validateMandatorySteps();
    if (vxm.users.MissedMandatorySteps.length && this.isLastStep) {
           this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
    } else {
          this.$emit('go-to-next');
    }
  }
}
